import React, { useEffect, Fragment } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import MediaQuery from 'react-responsive';
import { ReactSVG } from 'react-svg';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faBell,
  faInbox,
  faCoins,
  faUserChart,
  faCog,
  faFileInvoice,
  faCalendarExclamation,
  faUserCircle,
  faQuestionCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { faAmazon } from '@fortawesome/free-brands-svg-icons';

import './SideNav.scss';

library.add(
  faHome,
  faBell,
  faInbox,
  faCoins,
  faUserChart,
  faCog,
  faFileInvoice,
  faCalendarExclamation,
  faUserCircle,
  faQuestionCircle,
  faAmazon
);

function SideNav({ open, setOpen, sideNavFixed }) {
  const history = useHistory();

  useEffect(() => {
    if (!open) document.body.classList.remove('no-refresh');
  }, [open]);

  function onClickOption() {
    if (!sideNavFixed) setOpen(!open);
  }

  return (
    <Fragment>
      <nav
        id="_side-nav_"
        className={classnames(null, {
          open: sideNavFixed ? sideNavFixed : open,
        })}
      >
        {open && !sideNavFixed && (
          <Helmet>
            <body class="no-refresh" />
          </Helmet>
        )}
        <MediaQuery minWidth={1280}>
          <div className="facti-logo-header">
            <ReactSVG
              wrapper="span"
              className="logo"
              src="/assets/img/facti-new-logo (white).svg"
              fallback={() => <span>Facti - logo</span>}
              afterInjection={(error, svg) => {
                if (error) {
                  console.error(error);
                  return;
                }
                svg.removeAttribute('data-src');
              }}
              onClick={() => {
                history.push('/dashboard');
              }}
            />
            <svg
              className="curve"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              {/*
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              className="shape-fill"
            ></path>
            */}
              <path
                d="M741,116.23C291,117.43,0,27.57,0,6V120H1200V6C1200,27.93,1186.4,119.83,741,116.23Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </MediaQuery>

        <section>
          <h3>HOME</h3>
          <ul>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/dashboard"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'home']} />
                Dashboard
              </NavLink>
            </li>
            <MediaQuery maxWidth={1279}>
              <li>
                <NavLink
                  className="section"
                  activeClassName="is-active"
                  exact
                  to="/notifications"
                  onClick={onClickOption}
                >
                  <FontAwesomeIcon
                    style={{ transform: 'rotate(12deg)' }}
                    icon={['far', 'bell']}
                  />
                  Notificaciones
                </NavLink>
              </li>
            </MediaQuery>
          </ul>
        </section>
        <section>
          <h3>SERVICIOS</h3>
          <ul>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/my-invoices"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'inbox']} />
                Mis Facturas
              </NavLink>
            </li>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/invoicing"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'file-invoice']} />
                Facturación
              </NavLink>
            </li>
            {/*<li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/i-have-space"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['fab', 'amazon']} />I Have Space
              </NavLink>
            </li>*/}
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/collection"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'coins']} />
                Cobranza
              </NavLink>
            </li>
          </ul>
        </section>
        <section>
          <h3>AJUSTES</h3>
          <ul>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/my-organizations"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'user-chart']} />
                Mis Organizaciones
              </NavLink>
            </li>
            <li>
              <NavLink
                className="section"
                activeClassName="is-active"
                exact
                to="/settings"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'cog']} />
                Configuración
              </NavLink>
            </li>
          </ul>
        </section>
        <section>
          <h3>SOPORTE</h3>
          <ul>
            <li>
              <a
                className="section"
                rel="preload noopener noreferrer"
                href="https://ayuda.facti.mx"
                target="_blank"
                onClick={onClickOption}
              >
                <FontAwesomeIcon icon={['far', 'question-circle']} />
                Ayuda
              </a>
            </li>
          </ul>
        </section>
      </nav>
      <MediaQuery maxWidth={1279}>
        <div
          id="Blur"
          className={classnames('visooal-sideBlur', {
            show: open,
          })}
          onClick={onClickOption}
        ></div>
      </MediaQuery>
    </Fragment>
  );
}

SideNav.propTypes = {
  open: PropTypes.bool,
};

export default SideNav;
